module.exports = __webpack_public_path__ + "16162359ebebd62391a8d4593ebc1960.svg";